/**
 * #2133 設計 §3: ロールごとに使える画面を出し分ける。ProtectedRoute は
 * 「この Web を使えるか(admin・companyAssociate・studioAssociate)」だけを
 * 見るため、個々の画面(会社一覧は admin のみ等)はこのコンポーネントで
 * さらに絞り込む。対象外のロールは "/" へ戻す(存在しない操作を試みさせない)。
 */
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import type { Role } from '@/lib/roleFlags';

interface RequireRoleProps {
  allow: readonly Role[];
}

export function RequireRole({ allow }: RequireRoleProps) {
  const { roleFlags } = useAuth();

  if (roleFlags.role === null || !allow.includes(roleFlags.role)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
